import { render, staticRenderFns } from "./AssetClientCerts.vue?vue&type=template&id=0ca4d654&scoped=true&"
import script from "./AssetClientCerts.vue?vue&type=script&lang=ts&"
export * from "./AssetClientCerts.vue?vue&type=script&lang=ts&"
import style0 from "./AssetClientCerts.vue?vue&type=style&index=0&id=0ca4d654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4d654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
